export default __webpack_public_path__ + "static/media/icon_close.a9e51754.svg";